const EVENT_TRACKING_NAME = 'MaintenancePlans';
const EVENT_TRACKING_ACTIONS = {
  searchInputChanged: 'searchInputChanged',
  exportCSVClicked: 'exportCSVClicked',
  tableSortingChange: 'tableSortingChange',
  paginationChanged: 'paginationChanged',
  planClicked: 'planClicked',
};
const addToDataLayer = (data) => {
  window.dataLayer.push({
    event: EVENT_TRACKING_NAME,
    data: { ...data },
  });
};
export default function MaintenancePlansController(
  $scope,
  $filter,
  $uibModal,
  MaintenanceService,
  gettextCatalog,
) {
  'ngInject';

  $scope.loading = true;

  //Local Variables
  $scope.searchText = '';
  $scope.maintenancePlans = [];
  $scope.filteredMaintenancePlans = [];

  //Sorting
  $scope.predicate = 'name';
  $scope.reverse = false;

  //Pagination
  $scope.currentPage = 1;
  $scope.itemsPerPage = 30;
  $scope.maxSize = 3;

  //Sort filteredMaintenancePlans
  $scope.orderMaintenacePlan = function (predicate) {
    $scope.reverse = predicate === $scope.predicate ? !$scope.reverse : false;
    $scope.predicate = predicate;

    // Maintenance GTM tracking
    addToDataLayer({
      action: EVENT_TRACKING_ACTIONS.tableSortingChange,
      orderBy: predicate,
      descending: $scope.reverse,
    });
  };

  //applyFilter searchs the maintenancePlans[] for anything matching the search input.
  $scope.applyFilter = function () {
    if ($scope.searchText) {
      addToDataLayer({
        action: EVENT_TRACKING_ACTIONS.searchInputChanged,
      });
    }
    $scope.filteredMaintenancePlans = $filter('filter')($scope.maintenancePlans, $scope.searchText);
  };

  $scope.createButtonPressed = function () {
    let modalInstance = $uibModal.open({
      animation: true,
      template: require('./create/create.html'),
      controller: 'CreatePlanController',
      size: 'lg',
    });
  };

  MaintenanceService.getPlans().then(
    function (response) {
      $scope.maintenancePlans = response?.data?.map((plan) => {
        return {
          ...plan,
          frequency: (plan.recurrence.rules || [])
            .map(({ frequency, interval }) => `${interval} ${gettextCatalog.getString(frequency)}`)
            .join(` ${gettextCatalog.getString('or')} `),
          schedule_type: gettextCatalog.getString(plan.recurrence.algorithm),
        };
      });
      $scope.filteredMaintenancePlans = $scope.maintenancePlans.slice();
      $scope.loading = false;
    },
    function (error) {
      let errorMsg = gettextCatalog.getString(
        'An error occurred while retrieving maintenance plans',
      );
      if (error.data || error.status) {
        if (error.data.message) {
          errorMsg = error.data.message + ' ' + error.status.toString();
        } else {
          errorMsg += ': ' + error.status.toString();
        }
      } else {
        errorMsg += gettextCatalog.getString('. Please try again later.');
      }
      $scope.onLoadErrorFlag = true;
      $scope.onLoadErrorText = errorMsg;
      $scope.loading = false;
    },
  );

  let getEquipmentStatus = function () {
    function handleError(response) {
      $scope.error = gettextCatalog.getString('There was an error');
    }
    MaintenanceService.getStatus().then(function (response) {
      $scope.statusData = [];

      $scope.totalList = response.data;
    }, handleError);
  };

  getEquipmentStatus();

  //================csv ==============

  $scope.getCsvData = () => {
    addToDataLayer({
      action: EVENT_TRACKING_ACTIONS.exportCSVClicked,
    });
    return [
      {
        name: gettextCatalog.getString('Name'),
        description: gettextCatalog.getString('Description'),
        tags: gettextCatalog.getString('Tags'),
        frequency: gettextCatalog.getString('Frequency'),
        schedule_type: gettextCatalog.getString('Schedule Type'),
      },
      ...GetOrderedCSVList(),
    ];
  };

  function GetOrderedCSVList() {
    const list = $filter('orderBy')(
      $scope.filteredMaintenancePlans,
      $scope.predicate,
      $scope.reverse,
    );
    return list.map((plan) => {
      return {
        name: plan.name,
        description: plan.description,
        tags: (plan.tags || []).join(','),
        frequency: plan.frequency,
        schedule_type: plan.schedule_type,
      };
    });
  }

  $scope.paginationChanged = () => {
    addToDataLayer({
      action: EVENT_TRACKING_ACTIONS.paginationChanged,
      currentPage: $scope.currentPage,
    });
  };

  $scope.planClicked = (id) => {
    addToDataLayer({
      action: EVENT_TRACKING_ACTIONS.planClicked,
      planId: id,
    });
  };
}
